<template>
    <b-card class="mb-5">
        <b-row class="mb-2">
            <b-col md="10">
                <h3>{{$route.name}}</h3>
                <b-breadcrumb>
                    <b-breadcrumb-item><router-link to="/dashboard/">Dashboard</router-link></b-breadcrumb-item>
                    <b-breadcrumb-item active>{{ $route.name }}</b-breadcrumb-item>
                </b-breadcrumb>
            </b-col>
            <b-col md="2 mt-4">
                <b-button v-b-tooltip.hover.top title="Download to Excel" @click="doExportToExcel" variant="info" class="btn-download float-right"><font-awesome-icon icon="download"/></b-button>
            </b-col>
        </b-row>
        <div class="border-bottom"></div>
        <b-form v-on:submit.prevent="doFilter">
            <b-row>
                <b-col md="12">
                    <b-row class="mt-3 mb-1">
                        <b-col md="3 mb-1">
                            <b-form-input placeholder="Employee" v-model="tableFilter.search_employee"/>
                            <!-- <typeahead ref="technicianTypeahead" :preventAutofocus="false" :labelFields="['firstName', 'lastName']" :placeholder="'Search By Employee'" :urlSearch="apiUrl.profile" arr-response="profile" :model="tableFilter.userRequestedBy" v-on:afterHit="doFilter" customQueryParamName="search" /> -->
                        </b-col>
                        <b-col md="3 mb-1">
                            <b-form-select v-model="tableFilter.leaveType" :options="leaveList" />
                        </b-col>
                        <b-col md="3 mb-1">
                            <b-form-select v-model="tableFilter.statusLeave" :options="statusList" />
                        </b-col>
                        <b-col md="3 mb-1">
                            <button type="submit" class="ml-2 btn btn-primary float-right" id="btn-search"><font-awesome-icon icon="search"/> Filter</button>
                            <button @click="clearFilter()" class="ml-0 btn btn-outline-primary float-right" id="btn-search"><font-awesome-icon icon="times-circle"/> Clear Filter</button>
                        </b-col>
                    </b-row>
                </b-col>
            </b-row>
            <b-row>
                <b-col md="12 mb-1">
                    <div v-if="$store.getters['account/accountData'].roleDownStream[0].role === 'ADMIN'">
                        <b-row class="mt-2 mb-1">
                            <b-col md="3 mb-1">
                                <b-form-select v-model="tableFilter.parent" :options="parentList" />
                            </b-col>
                            <b-col md="3 mb-1">
                                <b-form-input placeholder="Approved By" v-model="tableFilter.search_approved_by"/>
                            </b-col>
                            <b-col md="3 mb-1">
                                <date-picker v-model="tableFilter.date" type="date" range placeholder="Date Range"></date-picker>
                            </b-col>
                        </b-row>
                    </div>
                    <div v-else>
                        <b-row class="mt-2 mb-1">
                            <!-- <b-col md="4">
                                <b-form-select v-model="tableFilter.parent" :options="parentList" />
                            </b-col> -->
                            <b-col md="3 mb-1">
                                <b-form-input placeholder="Approved By" v-model="tableFilter.search_approved_by"/>
                            </b-col>
                            <b-col md="3 mb-1">
                                <date-picker v-model="tableFilter.date" type="date" range placeholder="Date Range"></date-picker>
                            </b-col>
                        </b-row>
                    </div>
                </b-col>
            </b-row>
        </b-form>
        <paginated-table ref="dataTable" :can-approve="false" :can-reject="false" :can-paid="false" :can-delete="false" :can-edit="false" :data-url="apiUrl.leave" :data-key="dataKey" :data-columns="columns" :data-params="['search_employee', 'search_approved_by', 'requestedBy', 'parent_uuid', 'leave_type_uuid', 'leave_start_date', 'leave_end_date', 'requested_by', 'approved_by', 'rejected_by', 'status',
        'department_uuid']">
        </paginated-table>
    </b-card>
</template>
<script>
    import PaginatedTable from '@/components/PaginatedTable'
    import DatePicker from 'vue2-datepicker'
    import 'vue2-datepicker/index.css'
    import Typeahead from '@/components/Typeahead'
    export default {
        name: 'report-index',
        components: {
            PaginatedTable,
            DatePicker,
            Typeahead
        },
        data () {
            return {
                dataKey: 'leave',
                apiUrl: {
                    profile : window.AppConfig.apiUrl + 'profile',
                    leave : window.AppConfig.apiUrl + 'leave',
                    leaveType: window.AppConfig.apiUrl + 'leave-type',
                    exportLeave : window.AppConfig.apiUrl + 'export-leave-general',
                    department: window.AppConfig.apiUrl + 'department'
                },
                leaveList: [
                    {
                        value: null,
                        text: 'Type'
                    }
                ],
                statusList: [
                    {
                        value: null,
                        text: 'Status'
                    },
                    {
                        value: 'Requested',
                        text: 'Requested'
                    },
                    {
                        value: 'Approved',
                        text: 'Approved'
                    },
                    {
                        value: 'Rejected',
                        text: 'Rejected'
                    },
                    {
                        value: 'Canceled',
                        text: 'Canceled'
                    }
                ],
                departmentList: [
                  {
                    value: null,
                    text: 'All Department'
                  }
                ],
                parentList: [
                  {
                    value: null,
                    text: 'PIC Name'
                  }
                ],
                columns: [
                    {
                        key: 'requestedBy',
                        label: 'Employee',
                        sortable: true
                    },
                    {
                        key: 'startDate',
                        label: 'Start Date',
                        sortable: true
                    },
                    {
                        key: 'endDate',
                        label: 'End Date',
                        sortable: true
                    },
                    {
                        key: 'days',
                        label: 'Days',
                        sortable: true
                    },
                    {
                        key: 'leaveType',
                        label: 'Type',
                        sortable: true
                    },
                    {
                        key: 'note',
                        label: 'Note'
                    },
                    {
                        key: 'statusLeave',
                        label: 'Status'
                    },
                    {
                        key: 'actionLeaveIndex',
                        label: ''
                    }
                ],
                tableFilter: {
                    leaveType: null,
                    search_employee: this.$route.query.search_employee,
                    status: this.$route.query.status,
                    statusLeave: null,
                    search_approved_by: this.$route.query.search_approved_by,
                    requested_by: this.$route.query.requested_by,
                    approved_by: this.$route.query.approved_by,
                    rejected_by: this.$route.query.rejected_by,
                    leave_type_uuid: this.$route.query.leave_type_uuid,
                    department: null,
                    department_uuid: this.$route.query.department_uuid,
                    parent_uuid: this.$route.query.parent_uuid,
                    parent: null,
                    date: null,
                    leave_start_date: this.$route.query.leave_start_date,
                    leave_end_date: this.$route.query.leave_end_date,
                    userRequestedBy: {
                        value: null
                    },
                    userApprovedBy: {
                        value: null
                    },
                    userRejectedBy: {
                        value: null
                    }
                }
            }
        },
        watch: {
            // 'fakeTableFilter.requestedBy' (value) {
            //     this.tableFilter.requestedBy = value ? 1 : null
            //     this.doFilter()
            // },
            // 'tableFilter.date' (value) {
            //     if (value.length >= 1 && value[0] === null && value[1] === null) {
            //         this.tableFilter.date = null
            //         this.doFilter()
            //     } else {
            //         this.doFilter()
            //     }
            // },
            // 'tableFilter.leaveType' () {
            //     this.doFilter()
            // },
            // 'tableFilter.statusLeave' () {
            //     this.doFilter()
            // },
            // 'tableFilter.department' () {
            //     this.doFilter()
            // },
            // 'tableFilter.parent' () {
            //     this.doFilter()
            // }
        },
        mounted () {
            this.getleaveType()
            this.getDepartment()
            this.getPICName()
        },
        methods: {
            // doFilter () {
            //     this.tableFilter.parent_uuid = this.tableFilter.parent
            //     this.tableFilter.leave_type_uuid = this.tableFilter.leaveType
            //     this.tableFilter.status = this.tableFilter.statusLeave
            //     this.tableFilter.leave_start_date = this.tableFilter.date !== null ? this.$moment(this.tableFilter.date[0]).format('YYYY-MM-DD') : null
            //     this.tableFilter.leave_end_date = this.tableFilter.date !== null ? this.$moment(this.tableFilter.date[1]).format('YYYY-MM-DD') : null
            //     this.$refs.dataTable.doFilter(this.tableFilter)
            // },
            doFilter () {
                this.tableFilter.parent_uuid = this.tableFilter.parent
                this.tableFilter.leave_type_uuid = this.tableFilter.leaveType
                this.tableFilter.status = this.tableFilter.statusLeave
                this.tableFilter.approved_by = this.tableFilter.userApprovedBy.value
                this.tableFilter.requested_by = this.tableFilter.userRequestedBy.value
                // this.tableFilter.rejected_by = this.tableFilter.userRejectedBy.value
                this.tableFilter.department_uuid = this.tableFilter.department
                this.tableFilter.leave_start_date = this.tableFilter.date !== null ? this.$moment(this.tableFilter.date[0]).format('YYYY-MM-DD') : null
                this.tableFilter.leave_end_date = this.tableFilter.date !== null ? this.$moment(this.tableFilter.date[1]).format('YYYY-MM-DD') : null
                this.$refs.dataTable.doFilter(this.tableFilter)
            },
            clearFilter () {
                this.tableFilter.leaveType = null
                this.tableFilter.parent = null
                this.tableFilter.statusLeave = null
                this.tableFilter.search_employee = null
                this.tableFilter.search_approved_by = null
                this.tableFilter.date = null
                this.$refs.dataTable.doFilter(this.tableFilter)
            },
            getleaveType () {
                this.$http.get(this.apiUrl.leaveType + '?limit=100').then(resp => {
                    resp.data._embedded.leaveType.forEach(data => {
                        this.leaveList.push({
                            value: data.uuid,
                            text: data.name
                        })
                    })
                })
            },
            getPICName () {
              this.$http.get(window.AppConfig.apiUrl + 'user-access').then(response => {
                response.data._embedded.user_access.forEach(data => {
                  let employeeFirstName = data.userProfile.firstName !== null ? data.userProfile.firstName : ''
                  let employeeLastName = data.userProfile.lastName !== null ? data.userProfile.lastName : ''
                  let names = employeeFirstName + '\xa0' + employeeLastName
                  this.fullName = names
                  this.parentList.push({
                    value: data.userProfile.uuid,
                    text: this.fullName
                  })
                })
              })
            },
            getDepartment () {
              this.$http.get(this.apiUrl.department + '?limit=100').then(resp => {
                resp.data._embedded.department.forEach(data => {
                  this.departmentList.push({
                    value: data.uuid,
                    text: data.name
                  })
                })
              })
            },
            doExportToExcel () {
              let url = this.apiUrl.exportLeave + '?token=' + this.$store.getters['account/tokens'].access_token
              if (this.tableFilter.requested_by !== undefined && this.tableFilter.requested_by !== null) {
                url += '&requested_by=' + this.tableFilter.requested_by
              }
              if (this.tableFilter.approved_by !== undefined && this.tableFilter.approved_by !== null) {
                url += '&approved_by=' + this.tableFilter.approved_by
              }
              if (this.tableFilter.search_employee !== undefined && this.tableFilter.search_employee !== null) {
                url += '&search_employee=' + this.tableFilter.search_employee
              }
              if (this.tableFilter.search_approved_by !== undefined && this.tableFilter.search_approved_by !== null) {
                url += '&search_approved_by=' + this.tableFilter.search_approved_by
              }
            //   if (this.tableFilter.rejected_by !== undefined && this.tableFilter.rejected_by !== null) {
            //     url += '&rejected_by=' + this.tableFilter.rejected_by
            //   }
              if (this.tableFilter.leave_type_uuid !== undefined && this.tableFilter.leave_type_uuid !== null) {
                url += '&leave_type_uuid=' + this.tableFilter.leave_type_uuid
              }
              if (this.tableFilter.parent_uuid !== undefined && this.tableFilter.parent_uuid !== null) {
                url += '&parent_uuid=' + this.tableFilter.parent_uuid
              }
              if (this.tableFilter.status !== undefined && this.tableFilter.status !== null) {
                url += '&status=' + this.tableFilter.status
              }
              if (this.tableFilter.approved_by !== undefined && this.tableFilter.date !== null) {
                url += '&leave_start_date=' + this.$moment(this.tableFilter.date[0]).format('YYYY-MM-DD') + '&leave_end_date=' + this.$moment(this.tableFilter.date[1]).format('YYYY-MM-DD')
              }
              if (this.tableFilter.department_uuid !== undefined && this.tableFilter.department_uuid !== null) {
                url += '&department_uuid=' + this.tableFilter.department_uuid
              }
              window.open(url)
            },
            getDateTime (value) {
                if (value !== null) {
                    return this.$moment(value).format('YYYY-MM-DD HH:mm')
                } else {
                    return '-'
                }
            },
            reset () {
                this.tableFilter.requestedBy = null
            }
        }
    }
</script>